// Grids & Gantts — a field NAME, resolved against this site.
//
// A structure's config names fields the way a person does ("Start date",
// "Client Name"), never by id: the name survives a site rebuild, the id
// does not. These resolve a name against /api/fields at load time.

export const normName = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');

// "Project" / "Status" / "Work type" / "Summary" / "Due date" / "Created"
// are the built-ins; anything else is looked up by name.
export const BUILT_IN = {
  project: 'project', status: 'status', worktype: 'issuetype', issuetype: 'issuetype',
  summary: 'summary', duedate: 'duedate', due: 'duedate', created: 'created', key: 'key',
};

// A NAME IS LOOKED UP ONCE PER FIELD LIST. A formula column reads a field by
// name for every work item it adds up — `date("Stop")` over forty thousand
// rows, every redraw — and each lookup was a walk of the site's five hundred
// fields, normalising every name. The answer is kept per list (the page
// replaces its list, never edits it), so a new list is asked afresh.
const resolvedIn = new WeakMap();   // fieldList → Map(name → id | null)
export function resolveField(want, fieldList) {
  if (!want) return null;
  const w = String(want).trim();
  if (/^customfield_\d+$/.test(w)) return w;
  const list = Array.isArray(fieldList) ? fieldList : null;
  const known = list && resolvedIn.get(list);
  if (known && known.has(w)) return known.get(w);
  const b = BUILT_IN[normName(w)];
  let out = b || null;
  if (!b) {
    const target = normName(w);
    const hit = (list || []).find((f) => f && (normName(f.name) === target || f.id === w || f.key === w));
    out = hit ? (hit.id || hit.key) : null;
  }
  if (list) { if (known) known.set(w, out); else resolvedIn.set(list, new Map([[w, out]])); }
  return out;
}

export function fieldLabel(want, fieldList) {
  if (!want) return '';
  const id = resolveField(want, fieldList);
  const hit = (Array.isArray(fieldList) ? fieldList : []).find((f) => f && (f.id === id || f.key === id));
  return (hit && hit.name) || want;
}
